module.exports = __webpack_public_path__ + "static/img/iconfont.5ba13e04.svg";